/* ---Parse "Xm Ys" → total seconds--- */
export function parseTimeToSeconds(timeStr) {
  if (typeof timeStr !== 'string') {
    console.warn("Invalid timeStr:", timeStr);
    return 0;
  }

  var match = timeStr.match(/(?:(\d+)m)?\s*(?:(\d+)s)?/);

  // Fallback if regex doesn't match
  if (!match) {
    console.warn("Time string did not match expected format:", timeStr);
    return 0;
  }

  var minutes = parseInt(match[1] || 0, 10);
  var seconds = parseInt(match[2] || 0, 10);
  return minutes * 60 + seconds;
}

// Format seconds → "Xm Ys"
export function formatSecondsToTime(totalSeconds) {
  var minutes = Math.floor(totalSeconds / 60);
  var seconds = totalSeconds % 60;
  return minutes + "m " + seconds + "s";
}

/* ---Calculate time spent per subject for all tests--- */
export function getTimeSpentPerSubjectAllTests(payload) {
  var allResults = {};

  for (var testId in payload) {
    if (!payload.hasOwnProperty(testId)) continue;

    var testData = payload[testId];
    var subjectTimeMap = {};
    var totalSeconds = 0;

    if (!testData || !testData.items || !Array.isArray(testData.items)) {
      console.warn("Invalid test data for testId:", testId, testData);
      continue;
    }

    // Loop through each question
    for (var i = 0; i < testData.items.length; i++) {
      var question = testData.items[i];
      if (!question || typeof question.subject !== 'string' || typeof question.timespent !== 'number') {
        console.warn("Invalid question format in testId:", testId, question);
        continue;
      }

      var subjectKey = question.subject.toLowerCase();
      var timeSpentSeconds = Math.floor(question.timespent / 1000); // ms → s

      subjectTimeMap[subjectKey] = (subjectTimeMap[subjectKey] || 0) + timeSpentSeconds;
      totalSeconds += timeSpentSeconds;
    }

    // Convert seconds to "Xm Ys"
    var formattedSubjectTimes = {};
    for (var subject in subjectTimeMap) {
      if (subjectTimeMap.hasOwnProperty(subject)) {
        formattedSubjectTimes[subject] = formatSecondsToTime(subjectTimeMap[subject]);
      }
    }

    formattedSubjectTimes["total"] = formatSecondsToTime(totalSeconds);
    allResults[testId] = formattedSubjectTimes;
  }

  return allResults;
}

